/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetMainGrapesVariablesDTO = Types.Exact<{
  filter?: Types.Maybe<Types.MainGrapeFilterDTO>;
}>;


export type GetMainGrapesDTO = (
  { __typename?: 'Query' }
  & { mainGrapes: Array<(
    { __typename?: 'MainGrape' }
    & Pick<Types.MainGrapeDTO, 'id' | 'name'>
  )> }
);


export const GetMainGrapesDocumentDTO = gql`
    query getMainGrapes($filter: MainGrapeFilter) {
  mainGrapes(filter: $filter, sort: [{field: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useGetMainGrapes__
 *
 * To run a query within a React component, call `useGetMainGrapes` and pass it any options that fit your needs.
 * When your component renders, `useGetMainGrapes` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainGrapes({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetMainGrapes(baseOptions?: Apollo.QueryHookOptions<GetMainGrapesDTO, GetMainGrapesVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainGrapesDTO, GetMainGrapesVariablesDTO>(GetMainGrapesDocumentDTO, options);
      }
export function useGetMainGrapesLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetMainGrapesDTO, GetMainGrapesVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainGrapesDTO, GetMainGrapesVariablesDTO>(GetMainGrapesDocumentDTO, options);
        }
export type GetMainGrapesHookResult = ReturnType<typeof useGetMainGrapes>;
export type GetMainGrapesLazyQueryDTOHookResult = ReturnType<typeof useGetMainGrapesLazyQueryDTO>;
export type GetMainGrapesQueryResultDTO = Apollo.QueryResult<GetMainGrapesDTO, GetMainGrapesVariablesDTO>;